import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FiMessageCircle, FiX, FiSend, FiSmile, FiUsers, FiUser, FiPlus, FiArrowLeft, FiCheck, FiMic, FiImage, FiSettings, FiPaperclip, FiTrash2, FiMaximize2, FiMinimize2, FiVideo, FiPhone } from 'react-icons/fi';
import { BsPin, BsPinAngleFill } from 'react-icons/bs';
import {
    subscribeToDirectChats, subscribeToDirectMessages, sendDirectMessage, getOrCreateDirectChat,
    subscribeToGroupChats, subscribeToGroupMessages, sendGroupMessage, createGroupChat,
    deleteDirectMessageForMe, deleteDirectMessageForEveryone,
    deleteGroupMessageForMe, deleteGroupMessageForEveryone
} from '../../services/courseService';
import { getApprovedUsers } from '../../services/firestore';
import { useAuth } from '../../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import { storage, db } from '../../services/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { doc, updateDoc } from 'firebase/firestore';

// ─── Complete Emoji Set (categorized) ───
const EMOJI_CATEGORIES = {
    'Caritas': ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','🫡','🤐','🤨','😐','😑','😶','🫥','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠','🥳','🥸','😎','🤓','🧐','😕','🫤','😟','🙁','😮','😯','😲','😳','🥺','🥹','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡','👹','👺','👻','👽','👾','🤖'],
    'Gestos': ['👋','🤚','🖐️','✋','🖖','🫱','🫲','🫳','🫴','👌','🤌','🤏','✌️','🤞','🫰','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','🫵','👍','👎','✊','👊','🤛','🤜','👏','🙌','🫶','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','🦾','🦿','🦵','🦶','👂','🦻','👃','🧠','🫀','🫁','🦷','🦴','👀','👁️','👅','👄'],
    'Corazones': ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','❤️‍🩹','❣️','💕','💞','💓','💗','💖','💘','💝','💟','♥️','💋','💌','💐','🌹','🥀','🌺','🌸','💮','🏵️','🌻','🌼','🌷','🪻','🪷'],
    'Animales': ['🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐻‍❄️','🐨','🐯','🦁','🐮','🐷','🐸','🐵','🙈','🙉','🙊','🐒','🦍','🦧','🐔','🐧','🐦','🐤','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦄','🐝','🪱','🐛','🦋','🐌','🐞','🐜','🪰','🪲','🪳','🦟','🦗','🕷️','🦂','🐢','🐍','🦎','🦖','🦕','🐙','🦑','🦐','🦞','🦀','🐡','🐠','🐟','🐬','🐳','🐋','🦈','🐊','🐅','🐆','🦓','🦍','🐘','🦛','🦏','🐪','🐫','🦒','🦘','🦬','🐃','🐂','🐄','🐎','🐖','🐏','🐑','🦙','🐐','🦌','🐕','🐩','🦮','🐕‍🦺','🐈','🐈‍⬛','🪶','🐓','🦃','🦤','🦚','🦜','🦢','🦩','🕊️','🐇','🦝','🦨','🦡','🦫','🦦','🦥','🐁','🐀','🐿️','🦔'],
    'Comida': ['🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🫒','🧄','🧅','🥔','🍠','🫘','🥐','🥯','🍞','🥖','🥨','🧀','🥚','🍳','🧈','🥞','🧇','🥓','🥩','🍗','🍖','🦴','🌭','🍔','🍟','🍕','🫓','🥪','🥙','🧆','🌮','🌯','🫔','🥗','🥘','🫕','🥫','🍝','🍜','🍲','🍛','🍣','🍱','🥟','🦪','🍤','🍙','🍚','🍘','🍥','🥠','🥮','🍢','🍡','🍧','🍨','🍦','🥧','🧁','🍰','🎂','🍮','🍭','🍬','🍫','🍿','🍩','🍪','🌰','🥜','🍯','🥛','🍼','🫖','☕','🍵','🧃','🥤','🧋','🍶','🍺','🍻','🥂','🍷','🥃','🍸','🍹','🧉','🍾','🧊'],
    'Actividades': ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🪀','🏓','🏸','🏒','🏑','🥍','🏏','🪃','🥅','⛳','🪁','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛼','🛷','⛸️','🥌','🎿','⛷️','🏂','🏋️','🤸','⛹️','🤺','🤾','🏌️','🏇','🧘','🏄','🏊','🤽','🚣','🧗','🚴','🚵','🎖️','🏆','🥇','🥈','🥉','🏅','🎪','🎭','🎨','🎬','🎤','🎧','🎼','🎹','🥁','🪘','🎷','🎺','🪗','🎸','🪕','🎻','🎲','♟️','🎯','🎳','🎮','🕹️','🧩'],
    'Viajes': ['🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🏍️','🛵','🚲','🛴','🛺','🚨','🚔','🚍','🚘','🚖','🛞','🚡','🚠','🚟','🚃','🚋','🚞','🚝','🚄','🚅','🚈','🚂','🚆','🚇','🚊','🚉','✈️','🛫','🛬','💺','🚀','🛸','🛶','⛵','🚤','🛥️','🛳️','⛴️','🚢','🗼','🏰','🏯','🏟️','🎡','🎢','🎠','⛲','🏖️','🏝️','🏜️','🌋','⛰️','🏔️','🗻','🏕️','🛖','🏠','🏡','🏘️','🏚️','🏗️','🏢','🏬','🏣','🏤','🏥','🏦','🏨','🏪','🏫','🏩','💒','🏛️','⛪','🕌','🕍','🛕','🕋','⛩️','🗽','🗿'],
    'Objetos': ['⌚','📱','💻','⌨️','🖥️','🖨️','🖱️','🖲️','🕹️','🗜️','💽','💾','💿','📀','📼','📷','📸','📹','🎥','📽️','🎞️','📞','☎️','📟','📠','📺','📻','🎙️','🎚️','🎛️','🧭','⏱️','⏲️','⏰','🕰️','⌛','📡','🔋','🔌','💡','🔦','🕯️','🪔','🧯','🗑️','🛢️','💸','💵','💴','💶','💷','🪙','💰','💳','💎','⚖️','🪜','🧰','🪛','🔧','🔨','⚒️','🛠️','⛏️','🪚','🔩','⚙️','🪤','🧲','🔫','💣','🧨','🪓','🔪','🗡️','⚔️','🛡️','🚬','⚰️','🪦','⚱️','🏺','🔮','📿','🧿','🪬','💈','⚗️','🔭','🔬','🕳️','🩻','🩹','🩺','💊','💉','🩸','🧬','🦠','🧫','🧪','🌡️','🧹','🪠','🧺','🧻','🚰','🚿','🛁','🛀','🪥','🪒','🧴','🧽','🪣','🧯','🛒','🚬','🪞','🪟','🗿'],
    'Simbolos': ['💯','🔥','⭐','🌟','✨','⚡','💥','💢','💫','💦','💨','🕳️','💣','💬','👁️‍🗨️','🗨️','🗯️','💭','💤','🎵','🎶','🚫','❌','⭕','💮','♻️','✅','☑️','✔️','❎','➕','➖','➗','✖️','💲','💱','©️','®️','™️','〰️','➰','➿','❓','❔','❕','❗','‼️','⁉️','🔅','🔆','🔱','⚜️','🔰','♻️','🏳️','🏴','🏁','🚩','🏳️‍🌈','🏳️‍⚧️','⚠️','🔞','📵','🚭','❤️‍🔥','🫶','🤌','🫡','🫣','🫢','🫠','🥹']
};

// Sticker sets
const STICKER_SETS = {
    'Popular': ['👋😊','😂👍','❤️🔥','🎉🥳','😎✨','🤔💭','😢💔','🙏✅','💪🔥','🚀⭐'],
    'Reacciones': ['👍','👎','❤️','😂','😮','😢','😡','🎉','🤔','👀'],
};

const STICKER_IMAGES = [
    { id: 's1', emoji: '😂', label: 'LOL' },
    { id: 's2', emoji: '❤️', label: 'Love' },
    { id: 's3', emoji: '👍', label: 'OK' },
    { id: 's4', emoji: '🔥', label: 'Fire' },
    { id: 's5', emoji: '😎', label: 'Cool' },
    { id: 's6', emoji: '🤣', label: 'ROFL' },
    { id: 's7', emoji: '😍', label: 'Heart Eyes' },
    { id: 's8', emoji: '🥳', label: 'Party' },
    { id: 's9', emoji: '💪', label: 'Strong' },
    { id: 's10', emoji: '🙏', label: 'Please' },
    { id: 's11', emoji: '✅', label: 'Done' },
    { id: 's12', emoji: '🚀', label: 'Rocket' },
    { id: 's13', emoji: '💯', label: '100' },
    { id: 's14', emoji: '⭐', label: 'Star' },
    { id: 's15', emoji: '🎯', label: 'Target' },
    { id: 's16', emoji: '👀', label: 'Eyes' },
    { id: 's17', emoji: '🤝', label: 'Deal' },
    { id: 's18', emoji: '💰', label: 'Money' },
    { id: 's19', emoji: '📌', label: 'Pin' },
    { id: 's20', emoji: '🎉', label: 'Celebrate' },
];

// Chat background presets
const BG_PRESETS = [
    { id: 'default', name: 'Default', value: '#f8fafc', type: 'solid' },
    { id: 'whatsapp', name: 'WhatsApp', value: '#efeae2', type: 'solid' },
    { id: 'dark', name: 'Oscuro', value: '#0b141a', type: 'solid' },
    { id: 'sky', name: 'Cielo', value: '#e0f2fe', type: 'solid' },
    { id: 'mint', name: 'Menta', value: '#d1fae5', type: 'solid' },
    { id: 'lavender', name: 'Lavanda', value: '#ede9fe', type: 'solid' },
    { id: 'peach', name: 'Durazno', value: '#fff1e6', type: 'solid' },
    { id: 'rose', name: 'Rosa', value: '#ffe4e6', type: 'solid' },
    { id: 'pattern1', name: 'Patron', value: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%239C92AC\' fill-opacity=\'0.08\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") #f0f0f0', type: 'pattern' },
    { id: 'pattern2', name: 'Puntos', value: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'20\' height=\'20\' viewBox=\'0 0 20 20\'%3E%3Cg fill=\'%239C92AC\' fill-opacity=\'0.06\'%3E%3Ccircle cx=\'3\' cy=\'3\' r=\'3\'/%3E%3Ccircle cx=\'13\' cy=\'13\' r=\'3\'/%3E%3C/g%3E%3C/svg%3E") #f5f5f5', type: 'pattern' },
];

// ─── Notification Sound ───
// Use a proper WAV with correct length
const NOTIF_BEEP_FREQ = 880;
const NOTIF_BEEP_DURATION = 0.15;

let audioCtxReady = false;
const playNotificationSound = () => {
    try {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return;
        const ctx = new AudioCtx();
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.frequency.value = NOTIF_BEEP_FREQ;
        osc.type = 'sine';
        gain.gain.setValueAtTime(0.2, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + NOTIF_BEEP_DURATION);
        osc.start(ctx.currentTime);
        osc.stop(ctx.currentTime + NOTIF_BEEP_DURATION);
        // Second beep for emphasis
        const osc2 = ctx.createOscillator();
        const gain2 = ctx.createGain();
        osc2.connect(gain2);
        gain2.connect(ctx.destination);
        osc2.frequency.value = 1200;
        osc2.type = 'sine';
        gain2.gain.setValueAtTime(0.15, ctx.currentTime + 0.18);
        gain2.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.18 + NOTIF_BEEP_DURATION);
        osc2.start(ctx.currentTime + 0.18);
        osc2.stop(ctx.currentTime + 0.18 + NOTIF_BEEP_DURATION);
        audioCtxReady = true;
    } catch (e) {
        console.warn('Sound failed:', e);
    }
};

// Unlock audio on first user interaction (needed for mobile)
if (typeof document !== 'undefined') {
    const unlockAudio = () => {
        if (!audioCtxReady) {
            try {
                const AudioCtx = window.AudioContext || window.webkitAudioContext;
                if (AudioCtx) {
                    const ctx = new AudioCtx();
                    const buf = ctx.createBuffer(1, 1, 22050);
                    const src = ctx.createBufferSource();
                    src.buffer = buf;
                    src.connect(ctx.destination);
                    src.start(0);
                    audioCtxReady = true;
                }
            } catch {}
        }
        document.removeEventListener('touchstart', unlockAudio);
        document.removeEventListener('click', unlockAudio);
    };
    document.addEventListener('touchstart', unlockAudio, { once: true });
    document.addEventListener('click', unlockAudio, { once: true });
}

const getAvatarColor = (email) => {
    const colors = ['bg-blue-500','bg-green-500','bg-purple-500','bg-pink-500','bg-amber-500','bg-cyan-500','bg-rose-500','bg-indigo-500','bg-teal-500','bg-orange-500'];
    let hash = 0;
    for (let i = 0; i < (email || '').length; i++) hash = email.charCodeAt(i) + ((hash << 5) - hash);
    return colors[Math.abs(hash) % colors.length];
};

const formatTime = (ts) => {
    if (!ts) return '';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    const now = new Date();
    const isToday = d.toDateString() === now.toDateString();
    const yest = new Date(now); yest.setDate(yest.getDate() - 1);
    const time = d.toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' });
    if (isToday) return time;
    if (d.toDateString() === yest.toDateString()) return `Ayer ${time}`;
    return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit' }) + ' ' + time;
};

const Avatar = ({ photo, name, email, size = 7 }) => {
    const color = getAvatarColor(email);
    return photo ? (
        <img src={photo} alt="" className={`w-${size} h-${size} rounded-full object-cover`} />
    ) : (
        <div className={`w-${size} h-${size} rounded-full ${color} flex items-center justify-center`}>
            <span className={`text-white font-bold ${size >= 9 ? 'text-sm' : 'text-[10px]'}`}>
                {(name || '?').charAt(0).toUpperCase()}
            </span>
        </div>
    );
};

// ─── Audio Player ───
const AudioPlayer = ({ url, isMe }) => {
    const audioRef = useRef(null);
    const [playing, setPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);

    return (
        <div className="flex items-center gap-2 min-w-[180px]">
            <audio ref={audioRef} src={url} preload="metadata"
                onLoadedMetadata={() => setDuration(audioRef.current?.duration || 0)}
                onTimeUpdate={() => setProgress(audioRef.current ? (audioRef.current.currentTime / audioRef.current.duration) * 100 : 0)}
                onEnded={() => { setPlaying(false); setProgress(0); }}
            />
            <button onClick={() => { if (!audioRef.current) return; playing ? audioRef.current.pause() : audioRef.current.play(); setPlaying(!playing); }}
                className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${isMe ? 'bg-white/20 hover:bg-white/30 text-white' : 'bg-slate-200 hover:bg-slate-300 text-slate-700'}`}>
                {playing ? <svg width="12" height="12" viewBox="0 0 12 12"><rect x="1" y="1" width="4" height="10" rx="1" fill="currentColor"/><rect x="7" y="1" width="4" height="10" rx="1" fill="currentColor"/></svg>
                    : <svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 1l9 5-9 5V1z" fill="currentColor"/></svg>}
            </button>
            <div className="flex-1">
                <div className={`h-1.5 rounded-full overflow-hidden ${isMe ? 'bg-white/20' : 'bg-slate-200'}`}>
                    <div className={`h-full rounded-full transition-all ${isMe ? 'bg-white/70' : 'bg-slate-500'}`} style={{ width: `${progress}%` }} />
                </div>
                <p className={`text-[9px] mt-0.5 ${isMe ? 'text-white/60' : 'text-slate-400'}`}>
                    {duration > 0 ? `${Math.floor(duration / 60)}:${String(Math.floor(duration % 60)).padStart(2, '0')}` : '0:00'}
                </p>
            </div>
        </div>
    );
};

// ─── Video Player ───
const VideoPlayer = ({ url, isMe }) => (
    <video src={url} controls className="max-w-[220px] sm:max-w-[260px] rounded-lg" preload="metadata"
        style={{ maxHeight: '200px' }} />
);

// ─── Delete Menu ───
const DeleteMenu = ({ isMe, isPinned, onDeleteForMe, onDeleteForAll, onPin, onClose }) => (
    <div className="absolute z-20 bg-white rounded-xl shadow-xl border border-slate-200 py-1 min-w-[170px] animate-in"
        style={{ top: '100%', ...(isMe ? { right: 0 } : { left: 0 }) }}>
        {onPin && (
            <button onClick={onPin}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs text-amber-600 hover:bg-amber-50 transition-colors">
                <BsPin size={12} /> {isPinned ? 'Desfijar mensaje' : 'Fijar mensaje'}
            </button>
        )}
        <button onClick={onDeleteForMe}
            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-slate-600 hover:bg-slate-50 transition-colors">
            <FiTrash2 size={12} /> Eliminar para mí
        </button>
        {isMe && (
            <button onClick={onDeleteForAll}
                className="w-full flex items-center gap-2 px-3 py-2 text-xs text-red-600 hover:bg-red-50 transition-colors">
                <FiTrash2 size={12} /> Eliminar para todos
            </button>
        )}
        <button onClick={onClose}
            className="w-full flex items-center gap-2 px-3 py-2 text-xs text-slate-400 hover:bg-slate-50 transition-colors">
            <FiX size={12} /> Cancelar
        </button>
    </div>
);

// ─── Message Bubbles ───
const MessageBubbles = ({ messages, user, messagesEndRef, isDarkBg, onDeleteForMe, onDeleteForAll, onPinMessage, pinnedMessageId }) => {
    const isNewSender = (msg, idx) => idx === 0 || messages[idx - 1]?.senderEmail !== msg.senderEmail;
    const [previewMedia, setPreviewMedia] = useState(null);
    const [deleteMenuId, setDeleteMenuId] = useState(null);

    const userKey = user?.email?.replace(/\./g, '_');
    const visibleMessages = messages.filter(msg => !msg.deletedFor?.[userKey]);

    useEffect(() => {
        if (!deleteMenuId) return;
        const handler = () => setDeleteMenuId(null);
        document.addEventListener('click', handler);
        return () => document.removeEventListener('click', handler);
    }, [deleteMenuId]);

    return (
        <>
            {/* Pinned Message Banner */}
            {pinnedMessageId && (() => {
                const pinMsg = visibleMessages.find(m => m.id === pinnedMessageId);
                if (!pinMsg) return null;
                return (
                    <div className="sticky top-0 z-10 mx-1 mb-2 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5 flex items-center gap-2 shadow-sm cursor-pointer"
                        onClick={() => {
                            const el = document.getElementById(`msg-${pinnedMessageId}`);
                            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }}>
                        <BsPin size={12} className="text-amber-500 shrink-0" />
                        <p className="text-[11px] text-amber-800 truncate flex-1">
                            <span className="font-semibold">{pinMsg.senderName}: </span>
                            {pinMsg.text || (pinMsg.imageUrl ? '📷 Foto' : pinMsg.audioUrl ? '🎤 Audio' : pinMsg.videoUrl ? '🎬 Video' : pinMsg.sticker ? pinMsg.sticker : '')}
                        </p>
                    </div>
                );
            })()}

            {visibleMessages.length === 0 && (
                <div className="flex flex-col items-center justify-center h-full text-slate-400">
                    <FiMessageCircle size={36} className="mb-2 opacity-30" />
                    <p className="text-sm font-medium">Sin mensajes</p>
                    <p className="text-xs">Escribe el primer mensaje</p>
                </div>
            )}
            {visibleMessages.map((msg, idx) => {
                const isMe = msg.senderEmail === user?.email;
                const showAvatar = isNewSender(msg, idx);
                const isPinned = msg.id === pinnedMessageId;
                const isSticker = msg.sticker && !msg.text && !msg.imageUrl && !msg.audioUrl && !msg.videoUrl;

                if (isSticker) {
                    return (
                        <div key={msg.id} id={`msg-${msg.id}`} className={`flex ${isMe ? 'justify-end' : 'justify-start'} ${showAvatar && idx > 0 ? 'mt-2.5' : ''}`}>
                            <div className={`flex gap-1.5 max-w-[85%] ${isMe ? 'flex-row-reverse' : 'flex-row'} relative`}>
                                <div className="shrink-0 w-6 sm:w-7">
                                    {showAvatar && <Avatar photo={msg.senderPhoto} name={msg.senderName} email={msg.senderEmail} />}
                                </div>
                                <div className="relative">
                                    {showAvatar && !isMe && (
                                        <p className={`text-[10px] font-semibold mb-0.5 ml-1 ${isDarkBg ? 'text-slate-300' : 'text-slate-500'}`}>{msg.senderName}</p>
                                    )}
                                    <div className="text-5xl sm:text-6xl cursor-pointer select-none hover:scale-110 transition-transform"
                                        onContextMenu={(e) => { e.preventDefault(); setDeleteMenuId(msg.id); }}
                                        onDoubleClick={() => setDeleteMenuId(msg.id)}>
                                        {msg.sticker}
                                    </div>
                                    <p className={`text-[9px] ${isDarkBg ? 'text-slate-400' : 'text-slate-400'} ${isMe ? 'text-right' : ''}`}>
                                        {formatTime(msg.createdAt)}
                                    </p>
                                    {deleteMenuId === msg.id && (
                                        <div onClick={e => e.stopPropagation()}>
                                            <DeleteMenu isMe={isMe} isPinned={isPinned}
                                                onDeleteForMe={() => { onDeleteForMe(msg.id); setDeleteMenuId(null); }}
                                                onDeleteForAll={() => { onDeleteForAll(msg.id); setDeleteMenuId(null); }}
                                                onPin={() => { onPinMessage(msg.id); setDeleteMenuId(null); }}
                                                onClose={() => setDeleteMenuId(null)} />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                }

                return (
                    <div key={msg.id} id={`msg-${msg.id}`} className={`flex ${isMe ? 'justify-end' : 'justify-start'} ${showAvatar && idx > 0 ? 'mt-2.5' : ''}`}>
                        <div className={`flex gap-1.5 max-w-[85%] ${isMe ? 'flex-row-reverse' : 'flex-row'} group relative`}>
                            <div className="shrink-0 w-6 sm:w-7">
                                {showAvatar && <Avatar photo={msg.senderPhoto} name={msg.senderName} email={msg.senderEmail} />}
                            </div>
                            <div className="relative">
                                {showAvatar && !isMe && (
                                    <p className={`text-[10px] font-semibold mb-0.5 ml-1 ${isDarkBg ? 'text-slate-300' : 'text-slate-500'}`}>{msg.senderName}</p>
                                )}
                                <div className={`px-2.5 sm:px-3 py-1.5 rounded-2xl text-[13px] sm:text-sm leading-relaxed break-words ${
                                    isMe ? 'bg-[#005c4b] text-white rounded-tr-md shadow-sm' : 'bg-white text-slate-800 border border-slate-200/50 rounded-tl-md shadow-sm'
                                } ${isPinned ? 'ring-2 ring-amber-400/50' : ''}`}
                                    onContextMenu={(e) => { e.preventDefault(); setDeleteMenuId(msg.id); }}
                                    onDoubleClick={() => setDeleteMenuId(msg.id)}
                                >
                                    {isPinned && <span className="text-[9px] flex items-center gap-0.5 mb-0.5 opacity-70"><BsPin size={8} /> Fijado</span>}
                                    {msg.imageUrl && (
                                        <img src={msg.imageUrl} alt="" className="max-w-[180px] sm:max-w-[220px] rounded-lg mb-1 cursor-pointer hover:opacity-90 transition"
                                            onClick={() => setPreviewMedia({ type: 'image', url: msg.imageUrl })} />
                                    )}
                                    {msg.videoUrl && <VideoPlayer url={msg.videoUrl} isMe={isMe} />}
                                    {msg.audioUrl ? (
                                        <AudioPlayer url={msg.audioUrl} isMe={isMe} />
                                    ) : msg.text && !msg.imageUrl && !msg.videoUrl ? (
                                        <p className="whitespace-pre-wrap">{msg.text}</p>
                                    ) : msg.text && (msg.imageUrl || msg.videoUrl) ? (
                                        <p className="whitespace-pre-wrap text-xs mt-1">{msg.text}</p>
                                    ) : null}
                                    <p className={`text-[9px] mt-0.5 ${isMe ? 'text-green-200/70' : 'text-slate-400'} text-right`}>
                                        {msg.audioUrl && <span className="mr-1">🎤</span>}
                                        {msg.videoUrl && <span className="mr-1">🎬</span>}
                                        {formatTime(msg.createdAt)}
                                    </p>
                                </div>
                                {deleteMenuId === msg.id && (
                                    <div onClick={e => e.stopPropagation()}>
                                        <DeleteMenu isMe={isMe} isPinned={isPinned}
                                            onDeleteForMe={() => { onDeleteForMe(msg.id); setDeleteMenuId(null); }}
                                            onDeleteForAll={() => { onDeleteForAll(msg.id); setDeleteMenuId(null); }}
                                            onPin={() => { onPinMessage(msg.id); setDeleteMenuId(null); }}
                                            onClose={() => setDeleteMenuId(null)} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
            <div ref={messagesEndRef} />

            {/* Media Preview Modal */}
            {previewMedia && (
                <div className="fixed inset-0 z-[100] bg-black/80 flex items-center justify-center p-4" onClick={() => setPreviewMedia(null)}>
                    {previewMedia.type === 'image' && (
                        <img src={previewMedia.url} alt="" className="max-w-full max-h-full object-contain rounded-lg" />
                    )}
                    {previewMedia.type === 'video' && (
                        <video src={previewMedia.url} controls autoPlay className="max-w-full max-h-full rounded-lg" />
                    )}
                    <button className="absolute top-4 right-4 text-white bg-black/50 rounded-full p-2 hover:bg-black/70" onClick={() => setPreviewMedia(null)}>
                        <FiX size={20} />
                    </button>
                </div>
            )}
        </>
    );
};

// ─── Emoji Picker (Full) ───
const EmojiPicker = ({ onSelect, onClose }) => {
    const [activeCategory, setActiveCategory] = useState(Object.keys(EMOJI_CATEGORIES)[0]);
    const [search, setSearch] = useState('');

    const categoryIcons = { 'Caritas': '😀', 'Gestos': '👋', 'Corazones': '❤️', 'Animales': '🐶', 'Comida': '🍕', 'Actividades': '⚽', 'Viajes': '🚗', 'Objetos': '📱', 'Simbolos': '💯' };

    return (
        <div className="bg-white border-t border-slate-100 flex flex-col" style={{ height: '220px' }}>
            {/* Search */}
            <div className="px-2 py-1.5 border-b border-slate-100">
                <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar emoji..."
                    className="w-full px-2.5 py-1 text-xs border border-slate-200 rounded-lg outline-none focus:border-sky-400" />
            </div>
            {/* Category tabs */}
            <div className="flex gap-0.5 px-1 py-1 border-b border-slate-100 shrink-0 overflow-x-auto">
                {Object.keys(EMOJI_CATEGORIES).map(cat => (
                    <button key={cat} onClick={() => { setActiveCategory(cat); setSearch(''); }}
                        className={`px-1.5 py-0.5 rounded text-sm transition-colors shrink-0 ${activeCategory === cat && !search ? 'bg-sky-100' : 'hover:bg-slate-100'}`}
                        title={cat}>
                        {categoryIcons[cat]}
                    </button>
                ))}
            </div>
            {/* Emojis grid */}
            <div className="flex-1 overflow-y-auto px-1 py-1">
                <div className="grid grid-cols-8 gap-0.5">
                    {(search
                        ? Object.values(EMOJI_CATEGORIES).flat().filter(() => true) // show all when searching (emoji search is complex)
                        : EMOJI_CATEGORIES[activeCategory] || []
                    ).map((emoji, i) => (
                        <button key={`${emoji}-${i}`} onClick={() => onSelect(emoji)}
                            className="w-8 h-8 flex items-center justify-center text-lg hover:bg-slate-100 rounded-lg transition-colors active:scale-110">
                            {emoji}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

// ─── Sticker Picker ───
const StickerPicker = ({ onSend }) => (
    <div className="bg-white border-t border-slate-100 p-2" style={{ height: '180px', overflowY: 'auto' }}>
        <p className="text-[10px] font-bold text-slate-400 uppercase mb-1.5 px-1">Stickers</p>
        <div className="grid grid-cols-5 gap-2">
            {STICKER_IMAGES.map(s => (
                <button key={s.id} onClick={() => onSend(s.emoji)}
                    className="flex flex-col items-center gap-0.5 p-2 rounded-xl hover:bg-slate-100 transition-colors active:scale-95">
                    <span className="text-3xl">{s.emoji}</span>
                    <span className="text-[8px] text-slate-400">{s.label}</span>
                </button>
            ))}
        </div>
    </div>
);

// ─── Chat Input Bar ───
const ChatInput = ({ onSend, onSendAudio, onSendImage, onSendVideo, onSendSticker, inputRef }) => {
    const [text, setText] = useState('');
    const [showPanel, setShowPanel] = useState(null); // 'emoji' | 'sticker' | 'attach' | null
    const [recording, setRecording] = useState(false);
    const [recordTime, setRecordTime] = useState(0);
    const mediaRecorderRef = useRef(null);
    const chunksRef = useRef([]);
    const timerRef = useRef(null);
    const fileInputRef = useRef(null);
    const videoInputRef = useRef(null);

    const handleSend = () => {
        if (!text.trim()) return;
        onSend(text.trim());
        setText('');
        setShowPanel(null);
    };

    const startRecording = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const mimeType = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' :
                             MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : '';
            const mr = new MediaRecorder(stream, mimeType ? { mimeType } : undefined);
            chunksRef.current = [];
            mr.ondataavailable = (e) => { if (e.data.size > 0) chunksRef.current.push(e.data); };
            mr.onstop = () => {
                stream.getTracks().forEach(t => t.stop());
                const blob = new Blob(chunksRef.current, { type: mr.mimeType || 'audio/webm' });
                if (blob.size > 0) onSendAudio(blob);
            };
            mr.start();
            mediaRecorderRef.current = mr;
            setRecording(true);
            setRecordTime(0);
            timerRef.current = setInterval(() => setRecordTime(t => t + 1), 1000);
        } catch (err) {
            console.error('Microphone access denied:', err);
        }
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') mediaRecorderRef.current.stop();
        setRecording(false);
        if (timerRef.current) clearInterval(timerRef.current);
    };

    const cancelRecording = () => {
        if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
            mediaRecorderRef.current.ondataavailable = null;
            mediaRecorderRef.current.onstop = null;
            mediaRecorderRef.current.stop();
            const stream = mediaRecorderRef.current.stream;
            if (stream) stream.getTracks().forEach(t => t.stop());
        }
        chunksRef.current = [];
        setRecording(false);
        if (timerRef.current) clearInterval(timerRef.current);
    };

    const handleImageSelect = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        onSendImage(file, text.trim());
        setText('');
        setShowPanel(null);
        e.target.value = '';
    };

    const handleVideoSelect = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        if (file.size > 25 * 1024 * 1024) {
            alert('Video máximo 25MB');
            return;
        }
        onSendVideo(file, text.trim());
        setText('');
        setShowPanel(null);
        e.target.value = '';
    };

    const fmtTime = (s) => `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;

    const togglePanel = (panel) => setShowPanel(prev => prev === panel ? null : panel);

    return (
        <div className="shrink-0">
            {showPanel === 'emoji' && (
                <EmojiPicker
                    onSelect={(emoji) => { setText(p => p + emoji); inputRef.current?.focus(); }}
                    onClose={() => setShowPanel(null)}
                />
            )}
            {showPanel === 'sticker' && (
                <StickerPicker onSend={(sticker) => { onSendSticker(sticker); setShowPanel(null); }} />
            )}
            {showPanel === 'attach' && (
                <div className="bg-white border-t border-slate-100 px-3 py-2.5 flex gap-3 justify-center">
                    <button onClick={() => fileInputRef.current?.click()}
                        className="flex flex-col items-center gap-1 p-2 rounded-xl hover:bg-slate-100 transition-colors">
                        <div className="w-11 h-11 rounded-full bg-purple-500 flex items-center justify-center">
                            <FiImage size={20} className="text-white" />
                        </div>
                        <span className="text-[10px] text-slate-500">Foto</span>
                    </button>
                    <button onClick={() => videoInputRef.current?.click()}
                        className="flex flex-col items-center gap-1 p-2 rounded-xl hover:bg-slate-100 transition-colors">
                        <div className="w-11 h-11 rounded-full bg-red-500 flex items-center justify-center">
                            <FiVideo size={20} className="text-white" />
                        </div>
                        <span className="text-[10px] text-slate-500">Video</span>
                    </button>
                    <button onClick={() => fileInputRef.current?.click()}
                        className="flex flex-col items-center gap-1 p-2 rounded-xl hover:bg-slate-100 transition-colors">
                        <div className="w-11 h-11 rounded-full bg-blue-500 flex items-center justify-center">
                            <FiPaperclip size={20} className="text-white" />
                        </div>
                        <span className="text-[10px] text-slate-500">Archivo</span>
                    </button>
                </div>
            )}
            <input ref={fileInputRef} type="file" accept="image/*" onChange={handleImageSelect} className="hidden" capture="environment" />
            <input ref={videoInputRef} type="file" accept="video/*" onChange={handleVideoSelect} className="hidden" />
            <div className="bg-white border-t border-slate-200 px-2 sm:px-3 py-2 flex items-end gap-1">
                {recording ? (
                    <>
                        <button onClick={cancelRecording} className="p-1.5 rounded-full text-red-500 hover:bg-red-50 transition-colors shrink-0">
                            <FiX size={18} />
                        </button>
                        <div className="flex-1 flex items-center gap-2 bg-red-50 rounded-xl px-3 py-2">
                            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
                            <span className="text-sm font-medium text-red-600">{fmtTime(recordTime)}</span>
                            <span className="text-xs text-red-400">Grabando...</span>
                        </div>
                        <button onClick={stopRecording} className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 active:scale-90 transition-all shrink-0">
                            <FiSend size={15} />
                        </button>
                    </>
                ) : (
                    <>
                        <button onClick={() => togglePanel('emoji')}
                            className={`p-1.5 rounded-full transition-colors shrink-0 ${showPanel === 'emoji' ? 'bg-sky-100 text-sky-600' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100'}`}>
                            <FiSmile size={18} />
                        </button>
                        <button onClick={() => togglePanel('sticker')}
                            className={`p-1.5 rounded-full transition-colors shrink-0 ${showPanel === 'sticker' ? 'bg-sky-100 text-sky-600' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100'}`}
                            title="Stickers">
                            <span className="text-sm">🏷️</span>
                        </button>
                        <button onClick={() => togglePanel('attach')}
                            className={`p-1.5 rounded-full transition-colors shrink-0 ${showPanel === 'attach' ? 'bg-sky-100 text-sky-600' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100'}`}>
                            <FiPlus size={18} />
                        </button>
                        <textarea ref={inputRef} value={text} onChange={e => setText(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); } }}
                            onFocus={() => setShowPanel(null)}
                            placeholder="Mensaje"
                            className="flex-1 resize-none border border-slate-200 rounded-xl px-3 py-2 text-sm outline-none focus:border-sky-400 focus:ring-1 focus:ring-sky-100 max-h-20 transition-all"
                            rows={1} style={{ minHeight: '36px' }}
                        />
                        {text.trim() ? (
                            <button onClick={handleSend}
                                className="p-2 bg-[#005c4b] text-white rounded-full hover:bg-[#004a3d] active:scale-90 transition-all shrink-0">
                                <FiSend size={15} />
                            </button>
                        ) : (
                            <button onClick={startRecording}
                                className="p-2 bg-[#005c4b] text-white rounded-full hover:bg-[#004a3d] active:scale-90 transition-all shrink-0">
                                <FiMic size={15} />
                            </button>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

// ─── Background Settings ───
const BgSettings = ({ chatBg, setChatBg }) => {
    const fileRef = useRef(null);

    const handleUpload = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        try {
            const storageRef = ref(storage, `chat_backgrounds/${Date.now()}_${file.name}`);
            await uploadBytes(storageRef, file);
            const url = await getDownloadURL(storageRef);
            const bg = { id: 'custom', type: 'custom', value: `url("${url}") center/cover`, name: 'Custom' };
            setChatBg(bg);
            localStorage.setItem('chatBg', JSON.stringify(bg));
        } catch {
            const url = URL.createObjectURL(file);
            const bg = { id: 'custom', type: 'custom', value: `url("${url}") center/cover`, name: 'Custom' };
            setChatBg(bg);
        }
    };

    return (
        <div className="p-3 space-y-3">
            <h4 className="text-xs font-bold text-slate-700">Fondo del Chat</h4>
            <div className="grid grid-cols-5 gap-2">
                {BG_PRESETS.map(bg => (
                    <button key={bg.id} onClick={() => { setChatBg(bg); localStorage.setItem('chatBg', JSON.stringify(bg)); }}
                        className={`w-full aspect-square rounded-lg border-2 transition-all ${chatBg?.id === bg.id ? 'border-sky-500 scale-105 shadow-md' : 'border-slate-200 hover:border-slate-400'}`}
                        style={{ background: bg.value }} title={bg.name} />
                ))}
                <button onClick={() => fileRef.current?.click()}
                    className="w-full aspect-square rounded-lg border-2 border-dashed border-slate-300 hover:border-sky-400 flex items-center justify-center text-slate-400 hover:text-sky-500 transition-all">
                    <FiImage size={16} />
                </button>
            </div>
            <input ref={fileRef} type="file" accept="image/*" onChange={handleUpload} className="hidden" />
        </div>
    );
};

// ─── Chat size options ───
const CHAT_SIZES = {
    normal: { w: 'sm:w-[380px]', h: 'sm:h-[520px]' },
    large: { w: 'sm:w-[520px]', h: 'sm:h-[640px]' },
    xl: { w: 'sm:w-[680px]', h: 'sm:h-[75vh]' },
};

// ─── Main Global Chat Component ───
const GlobalChat = ({ embedded = false }) => {
    const { user } = useAuth();
    const location = useLocation();
    const isInboxPage = location.pathname.includes('/tareas/inbox');
    const [isOpen, setIsOpen] = useState(embedded ? true : false);
    const [tab, setTab] = useState('direct');
    const [unreadCount, setUnreadCount] = useState(0);
    const [chatSize, setChatSize] = useState(() => localStorage.getItem('chatSize') || 'normal');

    // Chat background
    const [chatBg, setChatBg] = useState(() => {
        try { return JSON.parse(localStorage.getItem('chatBg')) || BG_PRESETS[0]; } catch { return BG_PRESETS[0]; }
    });
    const [showBgSettings, setShowBgSettings] = useState(false);

    // Direct chats
    const [directChats, setDirectChats] = useState([]);
    const [activeDirectId, setActiveDirectId] = useState(null);
    const [directMessages, setDirectMessages] = useState([]);
    // Group chats
    const [groupChats, setGroupChats] = useState([]);
    const [activeGroupId, setActiveGroupId] = useState(null);
    const [groupMessages, setGroupMessages] = useState([]);
    // New chat/group creation
    const [showNewChat, setShowNewChat] = useState(false);
    const [allUsers, setAllUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [groupName, setGroupName] = useState('');
    const [loadingUsers, setLoadingUsers] = useState(false);
    // Pinned messages
    const [pinnedMessages, setPinnedMessages] = useState(() => {
        try { return JSON.parse(localStorage.getItem('pinnedMessages')) || {}; } catch { return {}; }
    });

    const messagesEndRef = useRef(null);
    const inputRef = useRef(null);

    // ── Subscribe direct chats ──
    useEffect(() => {
        if (!user?.uid) return;
        return subscribeToDirectChats(user.uid, (chats) => {
            setDirectChats(prev => {
                if (!isOpen && chats.length > 0) {
                    const totalNew = chats.reduce((sum, c) => {
                        const prevChat = prev.find(p => p.id === c.id);
                        if (prevChat && c.lastMessage !== prevChat.lastMessage && c.lastMessageAt) {
                            return sum + 1;
                        }
                        return sum;
                    }, 0);
                    if (totalNew > 0) {
                        setUnreadCount(u => u + totalNew);
                        playNotificationSound();
                    }
                }
                return chats;
            });
        });
    }, [user?.uid, isOpen]);

    // ── Subscribe group chats ──
    useEffect(() => {
        if (!user?.uid) return;
        return subscribeToGroupChats(user.uid, setGroupChats);
    }, [user?.uid]);

    // ── Subscribe active direct conversation ──
    useEffect(() => {
        if (!activeDirectId) { setDirectMessages([]); return; }
        return subscribeToDirectMessages(activeDirectId, (msgs) => {
            setDirectMessages(prev => {
                if (msgs.length > prev.length && msgs.length > 0) {
                    const lastMsg = msgs[msgs.length - 1];
                    if (lastMsg.senderEmail !== user?.email) playNotificationSound();
                }
                return msgs;
            });
        });
    }, [activeDirectId, user?.email]);

    // ── Subscribe active group conversation ──
    useEffect(() => {
        if (!activeGroupId) { setGroupMessages([]); return; }
        return subscribeToGroupMessages(activeGroupId, (msgs) => {
            setGroupMessages(prev => {
                if (msgs.length > prev.length && msgs.length > 0) {
                    const lastMsg = msgs[msgs.length - 1];
                    if (lastMsg.senderEmail !== user?.email) playNotificationSound();
                }
                return msgs;
            });
        });
    }, [activeGroupId, user?.email]);

    // Auto-scroll
    useEffect(() => {
        if (isOpen && messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [directMessages, groupMessages, isOpen, tab, activeDirectId, activeGroupId]);

    // Load users
    const loadUsers = useCallback(async () => {
        if (allUsers.length > 0) return;
        setLoadingUsers(true);
        try {
            const users = await getApprovedUsers();
            setAllUsers(users.filter(u => u.uid !== user?.uid));
        } catch (e) { console.error(e); }
        setLoadingUsers(false);
    }, [allUsers.length, user?.uid]);

    const handleOpen = () => { setIsOpen(true); setUnreadCount(0); setTimeout(() => inputRef.current?.focus(), 100); };
    const handleClose = () => { setIsOpen(false); setShowNewChat(false); setShowBgSettings(false); setActiveDirectId(null); setActiveGroupId(null); };

    const toggleSize = () => {
        const sizes = Object.keys(CHAT_SIZES);
        const next = sizes[(sizes.indexOf(chatSize) + 1) % sizes.length];
        setChatSize(next);
        localStorage.setItem('chatSize', next);
    };

    // ── Send handlers ──
    const msgPayload = (text) => ({
        text,
        senderEmail: user.email,
        senderName: user.displayName || user.email?.split('@')[0] || 'Usuario',
        senderPhoto: user.photoURL || null
    });

    const handleSendDirect = (text) => activeDirectId && sendDirectMessage(activeDirectId, msgPayload(text));
    const handleSendGroup = (text) => activeGroupId && sendGroupMessage(activeGroupId, msgPayload(text));

    // ── Audio ──
    const handleSendAudio = async (blob) => {
        try {
            const ext = blob.type.includes('mp4') ? 'mp4' : 'webm';
            const filename = `audio_${Date.now()}.${ext}`;
            const storageRef = ref(storage, `chat_audio/${user.uid}/${filename}`);
            await uploadBytes(storageRef, blob);
            const audioUrl = await getDownloadURL(storageRef);
            const payload = { ...msgPayload('🎤 Mensaje de voz'), audioUrl };
            if (tab === 'direct' && activeDirectId) await sendDirectMessage(activeDirectId, payload);
            else if (tab === 'group' && activeGroupId) await sendGroupMessage(activeGroupId, payload);
        } catch (err) { console.error('Error sending audio:', err); }
    };

    // ── Image ──
    const handleSendImage = async (file, caption) => {
        try {
            const filename = `img_${Date.now()}_${file.name}`;
            const storageRef = ref(storage, `chat_images/${user.uid}/${filename}`);
            await uploadBytes(storageRef, file);
            const imageUrl = await getDownloadURL(storageRef);
            const payload = { ...msgPayload(caption || ''), imageUrl };
            if (tab === 'direct' && activeDirectId) await sendDirectMessage(activeDirectId, payload);
            else if (tab === 'group' && activeGroupId) await sendGroupMessage(activeGroupId, payload);
        } catch (err) { console.error('Error sending image:', err); }
    };

    // ── Video ──
    const handleSendVideo = async (file, caption) => {
        try {
            const filename = `vid_${Date.now()}_${file.name}`;
            const storageRef = ref(storage, `chat_images/${user.uid}/${filename}`);
            await uploadBytes(storageRef, file);
            const videoUrl = await getDownloadURL(storageRef);
            const payload = { ...msgPayload(caption || '🎬 Video'), videoUrl };
            if (tab === 'direct' && activeDirectId) await sendDirectMessage(activeDirectId, payload);
            else if (tab === 'group' && activeGroupId) await sendGroupMessage(activeGroupId, payload);
        } catch (err) { console.error('Error sending video:', err); }
    };

    // ── Sticker ──
    const handleSendSticker = async (sticker) => {
        const payload = { ...msgPayload(''), sticker };
        if (tab === 'direct' && activeDirectId) await sendDirectMessage(activeDirectId, payload);
        else if (tab === 'group' && activeGroupId) await sendGroupMessage(activeGroupId, payload);
    };

    // ── Pin message ──
    const handlePinMessage = (messageId) => {
        const chatKey = activeDirectId || activeGroupId;
        if (!chatKey) return;
        const newPinned = { ...pinnedMessages };
        if (newPinned[chatKey] === messageId) {
            delete newPinned[chatKey];
        } else {
            newPinned[chatKey] = messageId;
        }
        setPinnedMessages(newPinned);
        localStorage.setItem('pinnedMessages', JSON.stringify(newPinned));
    };

    // ── Start direct chat ──
    const startDirectChat = async (otherUser) => {
        try {
            const chatId = await getOrCreateDirectChat(user, otherUser);
            setShowNewChat(false);
            setSelectedUsers([]);
            setTab('direct');
            setTimeout(() => setActiveDirectId(chatId), 200);
        } catch (err) { console.error('Error starting direct chat:', err); }
    };

    // ── Create group ──
    const handleCreateGroup = async () => {
        if (!groupName.trim() || selectedUsers.length === 0) return;
        try {
            const members = [{ uid: user.uid, email: user.email, displayName: user.displayName, photoURL: user.photoURL }, ...selectedUsers];
            const gid = await createGroupChat(groupName.trim(), members, user);
            setShowNewChat(false); setSelectedUsers([]); setGroupName('');
            setTab('group');
            setTimeout(() => setActiveGroupId(gid), 200);
        } catch (err) { console.error('Error creating group:', err); }
    };

    // ── Delete message handlers ──
    const handleDeleteForMe = async (messageId) => {
        try {
            if (tab === 'direct' && activeDirectId) {
                await deleteDirectMessageForMe(activeDirectId, messageId, user.email);
            } else if (tab === 'group' && activeGroupId) {
                await deleteGroupMessageForMe(activeGroupId, messageId, user.email);
            }
        } catch (err) { console.error('Error deleting message:', err); }
    };

    const handleDeleteForAll = async (messageId) => {
        try {
            if (tab === 'direct' && activeDirectId) {
                await deleteDirectMessageForEveryone(activeDirectId, messageId);
            } else if (tab === 'group' && activeGroupId) {
                await deleteGroupMessageForEveryone(activeGroupId, messageId);
            }
        } catch (err) { console.error('Error deleting message:', err); }
    };

    const toggleUserSelect = (u) => {
        setSelectedUsers(prev => prev.find(s => s.uid === u.uid) ? prev.filter(s => s.uid !== u.uid) : [...prev, u]);
    };

    const getOtherUserInfo = (chat) => {
        const otherId = chat.members?.find(m => m !== user?.uid);
        return chat.memberInfo?.[otherId] || { name: 'Usuario', email: '' };
    };

    if (!user) return null;

    const activeDirectChat = directChats.find(c => c.id === activeDirectId);
    const activeGroupChat = groupChats.find(c => c.id === activeGroupId);
    const inConversation = (tab === 'direct' && activeDirectId) || (tab === 'group' && activeGroupId);
    const currentMessages = tab === 'direct' ? directMessages : groupMessages;
    const currentSend = tab === 'direct' ? handleSendDirect : handleSendGroup;
    const activeChatKey = activeDirectId || activeGroupId;
    const currentPinnedId = pinnedMessages[activeChatKey] || null;

    let headerTitle = 'Mensajes Directos';
    let headerSub = `${directChats.length} conversaciones`;
    if (tab === 'direct' && activeDirectId && activeDirectChat) {
        const other = getOtherUserInfo(activeDirectChat);
        headerTitle = other.name;
        headerSub = other.email;
    } else if (tab === 'group' && activeGroupId && activeGroupChat) {
        headerTitle = activeGroupChat.name;
        headerSub = `${activeGroupChat.members?.length || 0} miembros`;
    } else if (tab === 'group' && !activeGroupId) {
        headerTitle = 'Grupos';
        headerSub = `${groupChats.length} grupos`;
    }

    const isDarkBg = chatBg?.id === 'dark';
    const bgStyle = chatBg?.type === 'pattern' || chatBg?.type === 'custom'
        ? { background: chatBg.value }
        : { backgroundColor: chatBg?.value || '#f8fafc' };

    const sizeClass = CHAT_SIZES[chatSize] || CHAT_SIZES.normal;

    return (
        <>
            {/* Floating Button - WhatsApp style (hidden on inbox and embedded) */}
            {!isOpen && !isInboxPage && !embedded && (
                <button onClick={handleOpen}
                    className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 bg-[#25d366] text-white rounded-full shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all flex items-center justify-center"
                    style={{ boxShadow: '0 4px 12px rgba(37,211,102,0.4)' }}>
                    <FiMessageCircle size={24} />
                    {unreadCount > 0 && (
                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1 animate-bounce">
                            {unreadCount > 99 ? '99+' : unreadCount}
                        </span>
                    )}
                </button>
            )}

            {/* Chat Panel */}
            {isOpen && (
                <div className={embedded
                    ? 'w-full h-full bg-white flex flex-col overflow-hidden'
                    : `fixed inset-0 sm:inset-auto sm:bottom-4 sm:right-4 z-50 ${sizeClass.w} ${sizeClass.h} bg-white sm:rounded-2xl shadow-2xl sm:border sm:border-slate-200/80 flex flex-col overflow-hidden`}
                    style={embedded ? {} : { animation: 'gchat-in 0.2s ease-out', maxHeight: '100dvh' }}>
                    {/* Header - WhatsApp style */}
                    <div className="bg-[#075e54] px-3 sm:px-4 py-2.5 shrink-0">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2 min-w-0 flex-1">
                                {inConversation && (
                                    <button onClick={() => { setActiveDirectId(null); setActiveGroupId(null); }}
                                        className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors shrink-0">
                                        <FiArrowLeft size={16} />
                                    </button>
                                )}
                                <div className="min-w-0 flex-1">
                                    <h3 className="text-white font-bold text-sm truncate">{headerTitle}</h3>
                                    <p className="text-white/60 text-[10px] truncate">{headerSub}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-0.5 shrink-0">
                                {/* Call buttons - only in direct conversations */}
                                {inConversation && tab === 'direct' && activeDirectChat && (() => {
                                    const otherUserId = activeDirectChat.members?.find(m => m !== user?.uid);
                                    const otherInfo = getOtherUserInfo(activeDirectChat);
                                    return (
                                        <>
                                            <button onClick={() => window.dispatchEvent(new CustomEvent('start-call', { detail: { calleeUser: { uid: otherUserId, ...otherInfo }, isVideo: false } }))}
                                                className="text-white/70 hover:text-white p-1.5 rounded-lg hover:bg-white/10 transition-colors" title="Llamada de voz">
                                                <FiPhone size={15} />
                                            </button>
                                            <button onClick={() => window.dispatchEvent(new CustomEvent('start-call', { detail: { calleeUser: { uid: otherUserId, ...otherInfo }, isVideo: true } }))}
                                                className="text-white/70 hover:text-white p-1.5 rounded-lg hover:bg-white/10 transition-colors" title="Videollamada">
                                                <FiVideo size={15} />
                                            </button>
                                        </>
                                    );
                                })()}
                                {/* Size toggle (desktop only) */}
                                <button onClick={toggleSize}
                                    className="hidden sm:flex text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors"
                                    title={chatSize === 'xl' ? 'Reducir' : 'Ampliar'}>
                                    {chatSize === 'normal' ? <FiMaximize2 size={14} /> : <FiMinimize2 size={14} />}
                                </button>
                                <button onClick={() => { setShowBgSettings(!showBgSettings); setShowNewChat(false); }}
                                    className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors">
                                    <FiSettings size={15} />
                                </button>
                                <button onClick={handleClose} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10 transition-colors">
                                    <FiX size={18} />
                                </button>
                            </div>
                        </div>

                        {!showNewChat && !showBgSettings && (
                            <div className="flex gap-1 mt-2">
                                {[
                                    { id: 'direct', icon: FiUser, label: 'Directo' },
                                    { id: 'group', icon: FiUsers, label: 'Grupos' },
                                ].map(t => (
                                    <button key={t.id}
                                        onClick={() => { setTab(t.id); setActiveDirectId(null); setActiveGroupId(null); }}
                                        className={`flex-1 flex items-center justify-center gap-1.5 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                                            tab === t.id ? 'bg-white/20 text-white' : 'text-white/50 hover:text-white/80 hover:bg-white/10'
                                        }`}>
                                        <t.icon size={13} /> {t.label}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Background Settings */}
                    {showBgSettings && (
                        <div className="flex-1 overflow-y-auto bg-white">
                            <BgSettings chatBg={chatBg} setChatBg={(bg) => { setChatBg(bg); setShowBgSettings(false); }} />
                        </div>
                    )}

                    {/* New Chat / Group Creator */}
                    {!showBgSettings && showNewChat && (
                        <div className="flex-1 overflow-y-auto bg-slate-50">
                            <div className="p-3 border-b bg-white">
                                <div className="flex items-center justify-between mb-2">
                                    <h4 className="font-bold text-sm text-slate-700">{showNewChat === 'direct' ? 'Nuevo Chat' : 'Crear Grupo'}</h4>
                                    <button onClick={() => { setShowNewChat(false); setSelectedUsers([]); setGroupName(''); }}
                                        className="text-slate-400 hover:text-slate-600 text-xs">Cancelar</button>
                                </div>
                                {showNewChat === 'group' && (
                                    <input value={groupName} onChange={e => setGroupName(e.target.value)} placeholder="Nombre del grupo..."
                                        className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm outline-none focus:border-sky-400 mb-2" />
                                )}
                                {showNewChat === 'group' && selectedUsers.length > 0 && (
                                    <div className="flex flex-wrap gap-1 mb-2">
                                        {selectedUsers.map(u => (
                                            <span key={u.uid} className="bg-sky-100 text-sky-700 text-[10px] font-medium px-2 py-0.5 rounded-full flex items-center gap-1">
                                                {u.displayName || u.email?.split('@')[0]}
                                                <button onClick={() => toggleUserSelect(u)} className="hover:text-red-500"><FiX size={10} /></button>
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="p-2">
                                {loadingUsers ? <p className="text-center text-slate-400 text-xs py-4">Cargando...</p>
                                : allUsers.length === 0 ? <p className="text-center text-slate-400 text-xs py-4">No hay otros usuarios</p>
                                : allUsers.map(u => (
                                    <button key={u.uid}
                                        onClick={() => showNewChat === 'direct' ? startDirectChat(u) : toggleUserSelect(u)}
                                        className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg transition-colors text-left ${
                                            selectedUsers.find(s => s.uid === u.uid) ? 'bg-sky-50 border border-sky-200' : 'hover:bg-slate-100'
                                        }`}>
                                        <Avatar photo={u.photoURL} name={u.displayName || u.email} email={u.email} />
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm font-medium text-slate-800 truncate">{u.displayName || u.email?.split('@')[0]}</p>
                                            <p className="text-[10px] text-slate-400 truncate">{u.email}</p>
                                        </div>
                                        {selectedUsers.find(s => s.uid === u.uid) && <FiCheck size={16} className="text-sky-600 shrink-0" />}
                                    </button>
                                ))}
                            </div>
                            {showNewChat === 'group' && selectedUsers.length > 0 && groupName.trim() && (
                                <div className="p-3 border-t bg-white">
                                    <button onClick={handleCreateGroup}
                                        className="w-full py-2 bg-[#075e54] text-white rounded-lg font-semibold text-sm hover:bg-[#064e46] active:scale-[0.98] transition-all">
                                        Crear Grupo ({selectedUsers.length + 1} miembros)
                                    </button>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Chat Lists */}
                    {!showBgSettings && !showNewChat && tab === 'direct' && !activeDirectId && (
                        <div className="flex-1 overflow-y-auto bg-slate-50">
                            <div className="p-2">
                                <button onClick={() => { setShowNewChat('direct'); loadUsers(); }}
                                    className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium text-[#075e54] hover:bg-[#075e54]/5 transition-colors mb-1">
                                    <FiPlus size={16} /> Nuevo Chat
                                </button>
                                {directChats.length === 0 && <p className="text-center text-slate-400 text-xs py-6">No tienes conversaciones</p>}
                                {directChats.map(chat => {
                                    const other = getOtherUserInfo(chat);
                                    return (
                                        <button key={chat.id} onClick={() => setActiveDirectId(chat.id)}
                                            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg hover:bg-white transition-colors text-left border border-transparent hover:border-slate-200">
                                            <Avatar photo={other.photo} name={other.name} email={other.email} />
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-semibold text-slate-800 truncate">{other.name}</p>
                                                <p className="text-[11px] text-slate-400 truncate">{chat.lastMessage || 'Sin mensajes'}</p>
                                            </div>
                                            {chat.lastMessageAt && <span className="text-[9px] text-slate-400 shrink-0">{formatTime(chat.lastMessageAt)}</span>}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {!showBgSettings && !showNewChat && tab === 'group' && !activeGroupId && (
                        <div className="flex-1 overflow-y-auto bg-slate-50">
                            <div className="p-2">
                                <button onClick={() => { setShowNewChat('group'); loadUsers(); }}
                                    className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium text-[#075e54] hover:bg-[#075e54]/5 transition-colors mb-1">
                                    <FiPlus size={16} /> Crear Grupo
                                </button>
                                {groupChats.length === 0 && <p className="text-center text-slate-400 text-xs py-6">No tienes grupos</p>}
                                {groupChats.map(chat => (
                                    <button key={chat.id} onClick={() => setActiveGroupId(chat.id)}
                                        className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-lg hover:bg-white transition-colors text-left border border-transparent hover:border-slate-200">
                                        <div className="w-9 h-9 rounded-full bg-[#075e54] flex items-center justify-center shrink-0">
                                            <FiUsers size={16} className="text-white" />
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className="text-sm font-semibold text-slate-800 truncate">{chat.name}</p>
                                            <p className="text-[11px] text-slate-400 truncate">{chat.lastMessage || `${chat.members?.length || 0} miembros`}</p>
                                        </div>
                                        {chat.lastMessageAt && <span className="text-[9px] text-slate-400 shrink-0">{formatTime(chat.lastMessageAt)}</span>}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Messages View */}
                    {!showBgSettings && !showNewChat && inConversation && (
                        <>
                            <div className="flex-1 overflow-y-auto p-2 sm:p-3 space-y-1" style={bgStyle}>
                                <MessageBubbles messages={currentMessages} user={user} messagesEndRef={messagesEndRef} isDarkBg={isDarkBg}
                                    onDeleteForMe={handleDeleteForMe} onDeleteForAll={handleDeleteForAll}
                                    onPinMessage={handlePinMessage} pinnedMessageId={currentPinnedId} />
                            </div>
                            <ChatInput onSend={currentSend} onSendAudio={handleSendAudio} onSendImage={handleSendImage}
                                onSendVideo={handleSendVideo} onSendSticker={handleSendSticker} inputRef={inputRef} />
                        </>
                    )}
                </div>
            )}

            <style>{`
                @keyframes gchat-in {
                    from { opacity: 0; transform: translateY(20px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }
                @keyframes animate-in {
                    from { opacity: 0; transform: scale(0.95); }
                    to { opacity: 1; transform: scale(1); }
                }
                .animate-in { animation: animate-in 0.15s ease-out; }
            `}</style>
        </>
    );
};

export default GlobalChat;
